// extracted by mini-css-extract-plugin
export var discard = "_1s-4";
export var muiTooltipTooltip = "_1s-6";
export var notificationBar = "_1s-3";
export var notificationContainer = "_1s-2";
export var saveButtonHoverSlotWrapper = "_1s-5";
export var show = "_1s-1";
export var spacer = "_1s-0";